module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listEntry",
    class: _vm.cardBgColor + ' ' + _vm.cardRarity
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.quantity > 1) ? _c('span', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.quantity) + "x")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "typeIcon",
    attrs: {
      "title": _vm.currentCard.type
    },
    domProps: {
      "innerHTML": _vm._s(_vm.typeToHtml)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.cardName)
    }
  }), _vm._v(" "), (_vm.showText) ? _c('span', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "types"
  }, [_vm._v(_vm._s(_vm.currentCard.type))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [(_vm.currentCard.cmc !== undefined) ? _c('div', {
    staticClass: "cmc",
    attrs: {
      "title": _vm.currentCard.manaCost
    },
    domProps: {
      "innerHTML": _vm._s(_vm.manaToHtml(_vm.currentCard.manaCost))
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.showText) ? _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.currentCardText)
    }
  }), _vm._v(" "), (_vm.currentCard.power) ? _c('div', {
    staticClass: "pt"
  }, [_vm._v("\n                " + _vm._s(_vm.currentCard.power) + "/" + _vm._s(_vm.currentCard.toughness) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showDescriptionText && _vm.currentCard.flavor != undefined) ? _c('div', {
    staticClass: "flavor"
  }, [_vm._v(_vm._s(_vm.currentCard.flavor))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-749f0664"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardViews/CardListEntry.vue
// module id = 136
// module chunks = 0